export default __webpack_public_path__ + "static/media/pdf.042f6ebb.svg";